import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../../../shared/shared.module';

import { TypeLieuComponent } from './typeLieu/type-lieu.component';
import { TypeCPVClassComponent } from './typeCPVClass/typeCPV-class.component';
import { TypeObjCPVComponent } from './typeObjCPV/type-objCPV.component';
import { TypeVoieComponent } from './typeVoie/type-voie.component';
import { TypeDescMarcheComponent } from './typeDescMarche/type-desc-marche.component';
import { AvisInitialTypeComponent } from './avisInitialType/avis-initial-type.component';
import { ProcedureComponent } from './procedure/procedure.component';
import { AnnulationComponent } from './annulation/annulation.component';
import { TypeTravauxComponent } from './typeTravaux/type-travaux.component';
import { TypeFournituresComponent } from './typeFournitures/type-fournitures.component';
import { FormMAPA_ANComponent } from './formmapa/form.mapa.an.component';
import { FormmapaCommonModule } from '../common/formmapa.module';
import { Step1Component } from './steps/step1/step1.component';
import { Step2Component } from './steps/step2/step2.component';
import { Step3Component } from './steps/step3/step3.component';

@NgModule({
  declarations: [
    TypeLieuComponent,
    TypeCPVClassComponent,
    TypeObjCPVComponent,
    TypeVoieComponent,
    TypeDescMarcheComponent,
    AvisInitialTypeComponent,
    ProcedureComponent,
    AnnulationComponent,
    TypeTravauxComponent,
    TypeFournituresComponent,
    FormMAPA_ANComponent,
    Step1Component,
    Step2Component,
    Step3Component
  ],
  exports: [
    FormMAPA_ANComponent
  ],
  imports: [
    CommonModule,
    ReactiveFormsModule, SharedModule, FormmapaCommonModule
  ]
})
export class FormmapaAnnulationModule {
}

